import { createListTrackingOnClick } from 'app/utils/statistics/clientStatistics';
import PropTypes from 'prop-types';
import React from 'react';
import env from '../../env';
import { PlayContainerBase } from '../../ui-components/PlayContainer/PlayContainer.styles';
import { PlayLink } from '../../ui-components/PlayLink.styles';
import PlayText, { TYPES } from '../../ui-components/typography/PlayText/PlayText';
import { generateListTracking } from '../../utils/contentoUtils.js';
import { isBrowser } from '../../utils/environment.js';
import get from '../../utils/get.js';
import ContentoQuery, { ContentoData, ContentoLoading } from '../Contento/ContentoQuery.js';
import PlayLinkExternal from '../Link/PlayLinkExternal.jsx';
import { Loading } from '../Recommendations/Recommendations.jsx';
import {
    Container,
    Content,
    Heading,
    List,
    ListHeading,
    RecommendationsCarousel,
    RecommendedShowcase,
} from './NotFound.styles';
import StartRecommendationsQuery from './StartRecommendations.graphql';

class NotFound extends React.Component {
    render() {
        return (
            <PlayContainerBase>
                <Container>
                    <Heading>Det finns inget på den här sidan</Heading>
                    <Content>
                        <ListHeading type="large">Det kan bero på:</ListHeading>
                        <List>
                            <li>Att du följt en länk som inte fungerar</li>
                            <li>Att programmet du försökt nå inte längre visas på SVT Play</li>
                        </List>
                        <ListHeading type="large">Du kan:</ListHeading>
                        <List>
                            <li>Ändra webbadressen</li>
                            <li>Göra en ny sökning överst på sidan</li>
                            <li>
                                Gå till{' '}
                                <PlayLink href="/" underline>
                                    Start
                                </PlayLink>{' '}
                                eller{' '}
                                <PlayLink href="/program" underline>
                                    Program
                                </PlayLink>
                            </li>
                        </List>
                        <PlayText type={TYPES.LARGE}>
                            Om du inte hittar det du söker,{' '}
                            <PlayLinkExternal url="https://kontakt.svt.se" text="kontakta oss" />.
                        </PlayText>
                    </Content>
                </Container>
                <ContentoQuery
                    query={StartRecommendationsQuery}
                    skip={!isBrowser()}
                    variables={{
                        includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
                    }}
                >
                    <ContentoData>
                        {(data) => {
                            const selection = get(data, 'startForSvtPlay.selections[0]');

                            if (!selection) {
                                return null;
                            }

                            const listTracking = generateListTracking(selection);

                            const onItemClick = createListTrackingOnClick(listTracking);

                            const props = {
                                header: 'Rekommenderat på SVT Play',
                                items: selection.items.slice(0, 6),
                                listTracking: listTracking,
                                onItemClick,
                            };

                            return (
                                <>
                                    <RecommendationsCarousel {...props} />
                                    <RecommendedShowcase {...props} />
                                </>
                            );
                        }}
                    </ContentoData>
                    <ContentoLoading>
                        <Loading header="Rekommenderat på SVT Play" />
                    </ContentoLoading>
                </ContentoQuery>
            </PlayContainerBase>
        );
    }
}

NotFound.propTypes = {
    baseContainer: PropTypes.bool,
};

export default NotFound;
